import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../constants/colors';
import { fontSize } from '../../../../../../constants/text';
import withTileAction from '../../util/withTileAction';

const Container = styled.div.withConfig({ componentId: 'sc-1xclalf-0' })`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  cursor: pointer;
`;

const ContentContainer = styled.div.withConfig({ componentId: 'sc-1xclalf-1' })`
  text-align: center;
  img {
    display: block;
    margin: 12px auto;
    width: 80%;
    height: auto;
  }
`;

const Title = styled.div.withConfig({ componentId: 'sc-1xclalf-2' })`
  color: ${colors.squid};
  font-size: ${fontSize.mediumSmall};
  text-align: center;
`;

const Action = styled.div.withConfig({ componentId: 'sc-1xclalf-3' })`
  color: ${colors.crunchBerry};
  font-size: ${fontSize.default};
  text-align: center;
  margin-top: 8px;
`;

type OwnProps = {
  classes: any;
  tileIndex: number;
  tile: any;
  userProfile: any;
  userLocations: any;
  isTelemed?: boolean;
  doTileAction?: (...args: any[]) => any;
};

type Props = OwnProps & typeof Default.defaultProps;

class Default extends PureComponent<Props> {
  static defaultProps = {
    isTelemed: false,
  };

  handleClick = (e: any) => {
    e && e.preventDefault();
    const { tileIndex, tile, userProfile, doTileAction } = this.props;

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    doTileAction(tileIndex, tile, userProfile, null);
  };

  render = () => (
    <Container onClick={this.handleClick}>
      <ContentContainer>
        <Title>{this.props.tile.title}</Title>

        <Action>Book Visit →</Action>
      </ContentContainer>
    </Container>
  );
}

export default withTileAction(Default);
